import React, { useState, useEffect, Component } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Bar, Line, Doughnut } from 'react-chartjs-2'
// import { getVisitorDashBoard } from 'redux/actions/getVisitorDashboardAction'
import moment from 'moment'
function GetComplainBarDashboard({ counterValue, chartBtn, dataCounterBtn }) {
  const [chartData, setChartData] = useState({})

  console.log(counterValue, ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>.")
  console.log(dataCounterBtn)
  console.log(chartBtn)

  const regenerateTokenRes = useSelector(
    ({ regenerateToken }) => regenerateToken
  );
  console.log("regenerateTokenRes", regenerateTokenRes);
  var authToken = regenerateTokenRes.data.AuthToken;
  // var bar_ctx;
  // var purple_orange_gradient = bar_ctx.createLinearGradient(0, 0, 0, 600);
  // purple_orange_gradient.addColorStop(0, 'orange');
  // purple_orange_gradient.addColorStop(1, 'purple');

  const Chart = () => {
    let dateArray = []

    let loadMoneyCountArray = []
    let purchaseMoneyCountArray = []
    let receivedMoneyCountArray = []
    let redeemMoneyCountArray = []
    let sendMoneyCountArray = []
    let withdrawMoneyCountArray = []

    // console.log(dateArray, loadMoneyCountArray, purchaseMoneyCountArray, receivedMoneyCountArray, redeemMoneyCountArray, sendMoneyCountArray, withdrawMoneyCountArray, "datearray")

    var counterDataResolvedArray = []
    var counterDataRejectedArray = []
    var counterDataPendingArray = []

    if (dataCounterBtn == 'weekly' || dataCounterBtn == 'monthly') {
      [].concat(counterValue).map((element) => {
        // debugger;
        // element.day
        //   ? dateArray.push(moment(element.day, 'YYYY/MM/DD').format('DD MMM'))
        //   : dateArray.push(
        //     moment(element.day, 'YYYY/MM/DD').format('DD MMM')
        //     //  +
        //     // ' - ' +
        //     // moment(element.toDate).format('DD MMM')
        //   )
        dataCounterBtn == 'weekly' ? dateArray.push(moment(element.day, 'YYYY/MM/DD').format('DD MMM')) : dateArray.push(element.month)
        // console.log(moment(element.day, 'YYYY/MM/DD').format('DD MMM'))

        loadMoneyCountArray.push(element.loadMoneyAmount)
        purchaseMoneyCountArray.push(element.purchaseMoneyAmount)
        receivedMoneyCountArray.push(element.receivedMoneyAmount)
        redeemMoneyCountArray.push(element.redeemMoneyAmount)
        sendMoneyCountArray.push(element.sendMoneyAmount)
        withdrawMoneyCountArray.push(element.withdrawMoneyAmount)
      })
    }
    // else {
    //   counterValue.forEach(function (element, index) {
    //     dateArray.push(
    //       element.month.slice(0, 3) +
    //       ' ' +
    //       Number(String(element.year).slice(2, 4))
    //     )

    //     loadMoneyCountArray.push(element.loadMoneyCount)
    //     purchaseMoneyCountArray.push(element.purchaseMoneyCount)
    //     receivedMoneyCountArray.push(element.receivedMoneyCount)
    //     redeemMoneyCountArray.push(element.redeemMoneyCount)
    //     sendMoneyCountArray.push(element.sendMoneyCount)
    //     withdrawMoneyCountArray.push(element.withdrawMoneyCount)
    //   })
    // }

    var bar_ctx = document.getElementById('bar-chart').getContext('2d');
    // var purple_orange_gradient = bar_ctx.createLinearGradient(0, 0, 0, 600);
    // var pink_white_gradient = bar_ctx.createLinearGradient(0, 0, 0, 600);
    // purple_orange_gradient.addColorStop(0, 'orange');
    // purple_orange_gradient.addColorStop(1, 'purple');
    // pink_white_gradient.addColorStop(1, 'white');
    // pink_white_gradient.addColorStop(0, 'pink');

    setChartData({
      labels: dateArray,
      datasets: [
        {
          label: 'Load',
          data: loadMoneyCountArray,
          backgroundColor: 'rgba(240, 135, 0,0.2)',
          borderColor: 'rgba(240, 135, 0,1)',
          borderWidth: 1,
          // backgroundColor: pink_white_gradient,
          // hoverBackgroundColor: pink_white_gradient,
          // hoverBorderWidth: 2,
          // hoverBorderColor: 'purple'
        },
        {
          label: 'Transaction',
          data: purchaseMoneyCountArray,
          backgroundColor: 'rgba(211, 63, 73,0.2)',
          borderColor: 'rgba(211, 63, 73,1)',
          borderWidth: 1,
          // backgroundColor: pink_white_gradient,
          // hoverBackgroundColor: pink_white_gradient,
          // hoverBorderWidth: 2,
          // hoverBorderColor: 'purple'
        },
        {
          label: 'Received',
          data: receivedMoneyCountArray,
          backgroundColor: 'rgba(66, 147, 51, 0.2)',
          borderColor: 'rgba(66, 147, 51, 1)',
          borderWidth: 1,
        },
        {
          label: 'Redeem',
          data: redeemMoneyCountArray,
          backgroundColor: 'rgba(240, 135, 0,0.2)',
          borderColor: 'rgba(240, 135, 0,1)',
          borderWidth: 1,
        },
        // {
        //   label: 'Transfer',
        //   data: sendMoneyCountArray,
        //   backgroundColor: 'rgba(211, 12, 73,0.2)',
        //   borderColor: 'rgba(211, 63, 73,1)',
        //   backgroundImage: "linear-gradient(to right top, #051937, #004d7a, #008793, #00bf72, #a8eb12)",
        //   borderWidth: 1,
        //   // backgroundColor: purple_orange_gradient,
        //   // hoverBackgroundColor: purple_orange_gradient,
        //   // hoverBorderWidth: 2,
        //   // hoverBorderColor: 'purple'
        // },
        {
          label: 'Send',
          data: sendMoneyCountArray,
          backgroundColor: 'rgba(211, 12, 73,0.2)',
          borderColor: 'rgba(211, 63, 73,1)',
          backgroundImage: "linear-gradient(to right top, #051937, #004d7a, #008793, #00bf72, #a8eb12)",
          borderWidth: 1,
          // backgroundColor: purple_orange_gradient,
          // hoverBackgroundColor: purple_orange_gradient,
          // hoverBorderWidth: 2,
          // hoverBorderColor: 'purple'
        },
        {
          label: 'Withdraw',
          data: withdrawMoneyCountArray,
          backgroundColor: 'rgba(66, 147, 51, 0.2)',
          borderColor: 'rgba(66, 147, 51, 1)',
          borderWidth: 1,
        },
      ],
    })
  }
  // const options = {
  //   plugins: {
  //     title: {
  //       display: true,
  //       text: 'Chart.js Bar Chart - Stacked',
  //     },
  //   },
  //   responsive: true,
  //   scales: {
  //     x: {
  //       stacked: true,
  //     },
  //     y: {
  //       stacked: true,
  //     },
  //   },
  // }

  // useEffect(() => {
  //   if (chartBtn == 'tablechart') {
  //     Chart(counterValue, dataCounterBtn)
  //   } else if (chartBtn == 'linechart') {
  //     Chart(counterValue, dataCounterBtn)
  //   } else {
  //     Chart(counterValue, dataCounterBtn)
  //   }
  // }, [counterValue])
  // useEffect(() => {
  //   Chart()
  // }, [])

  // useEffect(() => {
  //   Chart()
  // }, [counterValue])

  useEffect(() => {
    // if (regenerateTokenRes.data.status == "success") {
    Chart()
    // }
  }, [counterValue]);

  console.log(chartData)

  useEffect(() => {
    console.log(chartData, ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>.")
  }, [chartData])

  return (
    <div>
      <Bar
        data={chartData}
        height={130}
        options={{
          plugins: {
            title: {
              display: true,
              text: 'Chart.js Bar Chart - Stacked',
            },
          },
          responsive: true,
          scales: {
            y: {
              min: -15,
              max: 15,
              stepSize: 5,
            },
          },
        }}
      />
      <canvas id='bar-chart' height={0} width={0} />
    </div>
  )
}

export default GetComplainBarDashboard
